import { Injectable } from '@angular/core';
import { User } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class ChangeAvatarService {
  constructor(
    private readonly apollo: Apollo
  ) { }

  public async updateUser({ id, input }): Promise<User> {
    return this.apollo
      .query<any>({
        query: gql`
          mutation updateUser($id: ID!, $input: UserInput!) {
            updateUser(id: $id, input: $input) {
              id
            }
          }
        `,
        variables: {
          id,
          input
        }
      })
      .toPromise()
      .then((result) => result.data['updateUser'] as User);
  }
}
